import { createApp } from 'vue'
import App from './App.vue'
import 'typeface-sawarabi-mincho/index.css'

createApp(App).mount('#app')
